import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const key = (companies = []) => ['shutdownResponsible', ...companies];

const shutdownResponsibleQuery = async (companies) => {
  return await request.get(
    `/Request/executers`,
    { companies },
    `При загрузке ответственных за отключение произошла ошибка`
  );
};

export const useShutdownResponsible = (companies, options) =>
  useQuery(key(companies), () => shutdownResponsibleQuery(companies), options);
